var _$breakpoints_4 = {
  isMobile: window.matchMedia("(max-width: 500px)"),
  /* common-shake removed: isDesktop: window.matchMedia("(min-width: 501px)") */
};

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImJyZWFrcG9pbnRzLmpzIl0sIm5hbWVzIjpbIm1vZHVsZSIsImlzTW9iaWxlIiwid2luZG93IiwibWF0Y2hNZWRpYSJdLCJtYXBwaW5ncyI6IkFBQUFBLG1CQUFBQSxHQUFpQjtFQUNmQyxRQUFBQSxFQUFVQyxNQUFBQSxDQUFPQyxVQUFQRCxDQUFrQixvQkFBbEJBLENBREs7O0NBQWpCRixDQUFBQSIsInNvdXJjZXNDb250ZW50IjpbbnVsbF19